export const getSelectedType = (types, typeId) => {
    if (types.length === 1)
        return types[0];
    if (!typeId)
        return undefined;
    return types.find(option => option.id === typeId);
};
